import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-05-31 12:19:28
 * @LastEditTime: 2022-05-31 13:49:35
 * @FilePath: \insurforce-backstage-platform-side\src\views\system\labelManage\request.js
 */
import request from '@/utils/request';

// 标签列表
export function tagList(data) {
  return request.post('admin/tags/list', data);
}
// 标签分类
export function getTagsClass(data) {
  return request.post('admin/tags/getTagsClass', data);
}

// 标签新增
export function tagStore(data) {
  return request.post('admin/tags/store', data);
}
// 标签修改
export function tagEdit(data) {
  return request.post('admin/tags/edit', data);
}

// 标签详情
export function tagDetail(data) {
  return request.post('admin/tags/detail', data);
}

// 属性列表
export function tagAttributeList(data) {
  return request.post('admin/tags-attribute/list', data);
}

// 属性新增
export function tagAttributeStore(data) {
  return request.post('admin/tags-attribute/store', data);
}
// 属性修改
export function tagAttributeEdit(data) {
  return request.post('admin/tags-attribute/edit', data);
}

// 属性详情
export function tagAttributeDetail(data) {
  return request.post('admin/tags-attribute/detail', data);
}
// 获取标签列表无分页
export function tagsResource(data) {
  return request.post('admin/tags/resource', data);
}
// 获取属性列表无分页
export function tagsAttributeResource(data) {
  return request.post('admin/tags-attribute/resource', data);
}
// 添加标签和标签属性
export function addTag(data) {
  return request.post('admin/tags/addTag', data);
}
//根据分类获取标签和标签属性
export function getTags(data) {
  return request.post('admin/tags/getTags', data).then(res => {
    res.map(item => {
      item.children.map(item2 => {
        item2.choice = false;
      });
    });
    return res;
  });
}
//根据分类获取标签和标签属性(新)
export function getNewTags(data) {
  return request.post('admin/claims-record/getTags', data).then(res => {
    res.map(item => {
      item.children.map(item2 => {
        item2.choice = false;
      });
    });
    return res;
  });
}